<template>
  <div>
    <div class="common-form">编辑渠道用户</div>
    <el-form ref="form" :model="form" label-width="200px">
      <el-form-item label="渠道名称" :rules="[{ required: true, message: '渠道名称' }]" prop="channelName">
        <el-input class="max-w460" v-model="form.channelName"></el-input>
      </el-form-item>
      <el-form-item label="账号" :rules="[{ required: true, message: '账号不能为空' }]" prop="username">
        <el-input class="max-w460" v-model="form.username"></el-input>
      </el-form-item>
      <!-- <el-form-item label="密码" prop="password">
        <el-input class="max-w460" type="password" v-model="form.password"></el-input>
      </el-form-item> -->
      <el-form-item label="昵称" :rules="[{ required: true, message: '请输入昵称' }]" prop="nickname">
        <el-input class="max-w460" v-model="form.nickname"></el-input>
      </el-form-item>
      <el-form-item label="头像：" :rules="[{ required: true, message: '请上传头像图片' }]" prop="avatarUrl">
        <el-row>
          <div class="draggable-list">
            <div class="item img-select" v-if="form.avatarUrl == ''" @click="openProductUpload('image', 'image')">
              <i class="el-icon-plus"></i>
            </div>
            <div v-if="form.avatarUrl != ''" class="item" @click="openProductUpload('image', 'image')">
              <img :src="form.avatarurl" width="100" height="100" />
            </div>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="手机号" :rules="[{ required: true, message: '手机号不能为空' }]" prop="mobile">
        <el-input class="max-w460" v-model="form.mobile"></el-input>
      </el-form-item>

      <el-form-item label="余额">
        <el-input class="max-w460" v-model="form.balance"></el-input>
      </el-form-item>
      <!-- <el-form-item label="类型" :rules="[{ required: true, message: '请输入类型' }]" prop="type">
        <el-select class="max-w460" style="width:100%" v-model="form.type" placeholder="请输入类型">
          <el-option :value="1" label="代理"></el-option>
          <el-option :value="2" label="渠道"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代理等级" v-if="form.type == 1" :rules="[{ required: true, message: '请选择代理等级' }]"
        prop="agent_type">
        <el-select class="max-w460" style="width:100%" v-model="form.agent_type" placeholder="请选择代理等级">
          <el-option :value="1" label="一级分销"></el-option>
          <el-option :value="2" label="二级分销"></el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="上级代理" v-if="form.agent_type == 2 || form.type == 2"
        :rules="[{ required: true, message: '请选择上级代理' }]" prop="userId">
        <el-select class="max-w460" style="width:100%" v-model="form.userId" placeholder="请选择">
          <el-option v-for="(item, index) in agentlist" :key="index" :value="item.id" :label="item.username"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="分成比例" :rules="[{ required: true, message: '分成比例不能为空' }]" prop="scale">
        <el-input class="max-w460" v-model="form.scale"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">提交</el-button>

      </el-form-item>
    </el-form>
    <!--图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
  </div>
</template>

<script>
import ChannelApi from "@/api/channel.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload
  },
  data() {
    return {
      form: {
        channelName:'',
        username: "",
        
        nickname: null,
        mobile: null,
        // type: 1,
        // agent_type: null,
        balance: "0.00",
        avatarUrl: "",
        scale: ''
      },
      agentlist: [],
      imageId: "",
      filePath: "",
      isProductUpload: false,
      file_name: "image"
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getData();
    // this.getChanneloneAgent();
  },

  methods: {
    // 查询技师详情
    getData: function () {
      let self = this;
      ChannelApi.ChanneluserDetail(
        {
          userId: self.id
        },
        true
      )
        .then(res => {
          self.form = res.data;
          console.log('=========222', res.data.user)
         
        })
        .catch(error => {
          self.loading = false;
        });
    },

    getChanneloneAgent: function () {
      let self = this;
      ChannelApi.ChanneloneAgent(
        {
          id: self.id
        },
        true
      )
        .then(res => {
          // self.agentlist = res.data;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*打开上传图片*/
    openProductUpload: function (fileType, file_name) {
      this.file_name = file_name;
      if (fileType == "image") {
        this.config = {
          total: 1,
          fileType: "image"
        };
      } else if (fileType == "audio") {
        this.config = {
          total: 1,
          fileType: "audio"
        };
      } else {
        this.config = {
          total: 1,
          fileType: "video"
        };
      }
      this.isProductUpload = true;
    },
    /*上传活动图片*/
    returnProductImgsFunc(e) {
      console.log(e)
      if (e != null) {
        this.form.avatarUrl= e[0].filePath
        // if (this.file_name == "audio") {
        //   this.form.file_address = e[0];
        //   this.audio_url = e[0].filePath;
        // } else if (this.file_name == "music_image") {
        //   this.form.imageId = e[0].fileId;
        //   this.form.image.filePath = e[0].filePath;
        // }
      }
      this.isProductUpload = false;
    },

    // 修改技师
    onSubmit() {
      //
      let self = this;
      ChannelApi.ChanneluserEdit(self.form, true)
        .then(res => {
          if (res.code == 1) {
            self.$message({
              message: res.msg,
              type: "success",
            });
          }
          self.$router.push("/channel/channel/index");
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style scoped lang=''>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/channel/channel/edit.vue